import usersRouter from "./users.router";
import companiesRouter from "./companies.router";
import companiesEmisorasRouter from "./companies-emisoras.router";
import complaintsRouter from "./complaints.router";
import complaintsEmisorRouter from "./complaints-emisor.router";
import complaintsAgilizaRouter from "./complaints-agiliza.router";
import rolesRouter from "./roles.router";
import productivityRouter from "./productivity.router";
import managementRouter from "./management.router";
import duplicateComplaintsRouter from "./duplicate-complaints.router";
import directionsRouter from "./directions.router";
import alertsRouter from "./alerts.router";
import fcoRouter from "./fco.router";
import ratesRouter from "./rates.router";
import store from "../../../store";

export default [
  {
    path: "/dashboard",
    component: () => import("@/layouts/DashboardLayout.vue"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      // Excluir ruta específica del beforeEnter guard
      const detailsPath = '/dashboard/complaints-agiliza/details';
      if(to.path === detailsPath || to.path === `${detailsPath}/` || to.path.startsWith(`${detailsPath}/`)) {
        next();
        return;
      }
      if (store.getters["session/getRole"]) {
        next();
      } else {
        next("/customer");
      }
    },
    children: [
      {
        path: "",
        redirect: "home",
        component: () => import("@/views/dashboard/Home"),
        meta: {
          title: "Inicio",
          breadcrumb: [{ label: "Inicio", link: "/" }],
        },
      },
      {
        path: "home",
        component: () => import("@/views/dashboard/Home"),
        meta: {
          title: "Inicio",
          breadcrumb: [{ label: "Inicio", link: "/" }],
        },
      },
      ...alertsRouter,
      ...usersRouter,
      ...complaintsRouter,
      ...complaintsEmisorRouter,
      ...complaintsAgilizaRouter,
      ...companiesRouter,
      ...companiesEmisorasRouter,
      ...rolesRouter,
      ...directionsRouter,
      ...productivityRouter,
      ...managementRouter,
      ...duplicateComplaintsRouter,
      ...fcoRouter,
      ...ratesRouter,
    ],
  },
];
